import ApiService from "../../restapi";

export const getClientDiaryApiService = async ({ clientId, startAfter, limit }) => {
  return await ApiService.sendRequest({
    url: `/clients/${clientId}/diary`,
    query: {
      startAfter: startAfter,
      limit: limit,
    },
    method: "GET",
    headers: {},
  });
};

export const createClientDiaryEntryApiService = async ({ clientId, notes, additionalStaff }) => {
  return await ApiService.sendRequest({
    url: `/clients/${clientId}/diary`,
    query: {},
    method: "POST",
    headers: {},
    body: {
      notes: notes,
      additionalStaff: additionalStaff,
    },
  });
};